import { Button, Typography } from '@mui/material'
import { useState } from 'react'
import AuthenticationService from 'app/services/api/authentication/authentication.service'
import {
  getMaintenanceMessage,
  isMaintenanceModeError,
} from 'app/services/utils/maintenanceMode'
import { useAppDispatch } from 'app/services/hooks/store-hooks'
import {
  activateMaintenance,
  recoverFromMaintenance,
} from 'app/store/slice/maintenanceSlice'

const MaintenanceImg = '/assets/Error.svg'

export function MaintenanceMode({ message }: { message: string }) {
  const dispatch = useAppDispatch()
  const [checking, setChecking] = useState(false)

  const handleCheckAgain = async () => {
    if (checking) return

    setChecking(true)
    try {
      await AuthenticationService.login()
      dispatch(recoverFromMaintenance())
    } catch (error) {
      if (isMaintenanceModeError(error)) {
        dispatch(
          activateMaintenance({
            message: getMaintenanceMessage(error),
          })
        )
      }
    } finally {
      setChecking(false)
    }
  }

  return (
    <section className='flex items-center h-full p-16'>
      <div className='container flex flex-col items-center justify-center px-5 mx-auto my-8'>
        <img
          width='631'
          height='379'
          src={process.env.PUBLIC_URL + MaintenanceImg}
          alt='Maintenance Mode'
        />
        <div className='max-w-2xl text-center'>
          <Typography className='text-2xl font-semibold md:text-3xl'>
            We are under maintenance
          </Typography>
          <p className='mt-4 mb-8'>{message}</p>
          <Button
            onClick={handleCheckAgain}
            variant='contained'
            disabled={checking}
          >
            {checking ? 'Checking...' : 'Check Again'}
          </Button>
        </div>
      </div>
    </section>
  )
}
